/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { projectsList } from "../funcs/projectsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListProjectsResult } from "../models/components/listprojectsresult.js";
import {
  ListProjectsRequest,
  ListProjectsSecurity,
} from "../models/operations/listprojects.js";
import { unwrapAsync } from "../types/fp.js";
export type ListProjectsQueryData = ListProjectsResult;

export function prefetchListProjects(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListProjectsRequest,
  security?: ListProjectsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListProjectsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListProjectsQuery(
  client$: GramCore,
  request: ListProjectsRequest,
  security?: ListProjectsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ListProjectsQueryData>;
} {
  return {
    queryKey: queryKeyListProjects({
      organizationId: request.organizationId,
      gramKey: request.gramKey,
      gramSession: request.gramSession,
    }),
    queryFn: async function listProjectsQueryFn(
      ctx,
    ): Promise<ListProjectsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(projectsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListProjects(
  parameters: {
    organizationId: string;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "projects", "list", parameters];
}
